/**
 * management pokemon list
 */
const state={
    pokemon_list:null//ポケモンの名前一覧
};

const getters={
    getPokemonList(state){
        return state.pokemon_list;
    },
};

const mutations={
    /**
     * サーバ側から送られてきたポケモンの名前一覧を登録
     * @param {String[]} pokemon_list
     */
    savePokemonList(state,pokemon_list){
        state.pokemon_list=pokemon_list;
    },
};

const actions={
    savePokemonList({commit},pokemon_list){
        commit("savePokemonList",pokemon_list);
    },
};

const pokemonList={
    namespaced:true,//important
    state,
    getters,
    actions,
    mutations
};

export default pokemonList;